import React from 'react'
import { Grid, Icon, useTheme } from '@mui/material'
import { RecentlyOpenedWorkorder, ResultObjectType } from '@cbgms/api'
import { manufacturerToClass } from '@cbgms/components/src/utils/vehicle'
import { VehicleSearchLine } from './VehicleSearchLine'
import { ResultTitle } from '../../Results/Title'
import FullName from '@cbgms/components/src/utils/FullName'

interface RecentlyOpenedWorkOrderProps {
  workOrder: RecentlyOpenedWorkorder
  resultType: ResultObjectType
  hasGroupHeader: boolean
}

export const RecentlyOpenedWorkOrder: React.FC<RecentlyOpenedWorkOrderProps> = props => {
  const { workOrder, resultType, hasGroupHeader } = props
  const theme = useTheme()

  return (
    <div>
      <Grid container spacing={2}>
        <ResultTitle resultType={resultType} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={2}>
          <Icon className={`icon vehicle brand ${manufacturerToClass(workOrder.Manufacturer)}`} fontSize='large' />
        </Grid>
        <Grid item xs={10}>
          {workOrder.Registration ? (
            <VehicleSearchLine workorder={workOrder} />
          ) : (
            <FullName firstName={workOrder.FirstName} prefix={workOrder.NamePrefix} lastName={workOrder.Name} />
          )}
        </Grid>
        <Grid item xs={12}>
          <span style={{ color: theme.palette.text.primary }}>
            {workOrder.WorkorderID}
            {workOrder.Registration && (
              <span className='pl1'>
                <FullName firstName={workOrder.FirstName} prefix={workOrder.NamePrefix} lastName={workOrder.Name} />
              </span>
            )}
          </span>
        </Grid>
      </Grid>
    </div>
  )
}
